import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ProviderportalService } from '../../providerportal.service';
import { saveAs } from 'file-saver';
import { PqvDashboardService } from "../services/pqvDashboard.services";
import { Output, EventEmitter,OnChanges } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-clinical-visit',
  templateUrl: './clinical-visit.component.html',
  styleUrl: './clinical-visit.component.scss',
})
export class ClinicalVisitComponent implements OnInit, AfterViewInit,OnChanges  {
  fromDate: Date| undefined;
  toDate: Date| undefined;
  rangeDates: Date[];
  minDate: Date;
  maxDate: Date;
  startMinDate: Date;
  startMaxDate: Date;
  endMinDate: Date;
  endMaxDate: Date;
  disableToDate: boolean;
  disableClaimsBtn: boolean;
  fromDateValue: any;
  endDateValue: any;
  fromDateWithFormat: any;
  toDateWithFormat: any;
  @Input() filesData;
 @Output() dateRangeSelected = new EventEmitter<DateRange>();
  @Output() dateRangeSelected1 = new EventEmitter<DateRange>();
  displayedColumns: string[] = ['encounterdate', 'encountertype', 'encountervisitname','memberName','id'];
  dataSource = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  showSpinner = false;
  download(id: any,edate: any,ename: any) {
    this.showSpinner = true;
    //this.providerportalService.getDocument(id, 'ATHENA_DOC', null).subscribe(
      this.pqvService.getEncounterDocument(id).subscribe(data => {   
        saveAs(data, "Encounter_"+ename+"_"+edate+".pdf"); 
        this.showSpinner = false;
      },
      (err) => {
        this.showSpinner = false;
      }
    );
  }
  constructor(private providerportalService: ProviderportalService,
    private pqvService: PqvDashboardService
  ) {}


  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  binary64ToBlob(binary64String, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    const byteCharacters = atob(binary64String);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  ngOnInit() {
    // this.loadTabBackendData();
    this.dataSource.data = this.filesData;
    //this.dataSource.sort = this.sort;
    this.disableToDate = true;
     this.disableClaimsBtn = true;
    let today = new Date();
    let month = today.getMonth();
    let year = today.getFullYear();
    let date = today.getDate();
    this.startMinDate = new Date();
    this.startMinDate.setMonth(today.getMonth());
    this.startMinDate.setFullYear(today.getFullYear()-100);
    this.startMaxDate = new Date();
  }

  //   loadTabBackendData() {
  //   this.showSpinner = true; 

  //   setTimeout(() => {
  //     this.showSpinner = false; 
  //   }, 3000);
  // }

    onFromSelect(event: any) {
      //console.log("from select :",event)
    this.toDate = undefined;
    let selectedMonth = this.fromDate.getMonth();
    this.disableToDate = false;
    this.endMinDate = new Date();
    this.endMaxDate = new Date();
   
    if(selectedMonth > 5){
      let nextMonth = 0; 
      this.endMinDate.setDate(this.fromDate.getDate());
      this.endMinDate.setMonth(this.fromDate.getMonth());
      this.endMinDate.setFullYear(this.fromDate.getFullYear());
      this.endMaxDate.setDate(this.fromDate.getDate());
      //this.endMaxDate.setMonth(nextMonth);
       this.endMaxDate.setMonth(this.fromDate.getMonth()+6);
      this.endMaxDate.setFullYear(this.fromDate.getFullYear()+1);
    }
    else {
      this.endMinDate.setDate(this.fromDate.getDate());
      this.endMinDate.setMonth(this.fromDate.getMonth());
      this.endMinDate.setFullYear(this.fromDate.getFullYear());
      this.endMaxDate.setDate(this.fromDate.getDate());
      this.endMaxDate.setMonth(this.fromDate.getMonth()+6);
      this.endMaxDate.setFullYear(this.fromDate.getFullYear());
      
    }
  }

    onToSelect(event: any) {
    //console.log("to select :",event)
    this.disableClaimsBtn = false;
  }

  searchEncounter() {
    if (this.fromDate && this.toDate) {
      const range: DateRange = {
        fromDate: this.fromDate,
        toDate: this.toDate
      };
     this.dateRangeSelected.emit(range);
    } 
  }

  clearDates () {
    this.fromDate = undefined;
    this.toDate = undefined
    this.dateRangeSelected1.emit({ fromDate: null, toDate: null })
  }

    ngOnChanges(changes: SimpleChanges) {
    // Check if a specific input changed
    if (changes['filesData']) {
      const current = changes['filesData'].currentValue;
      //const previous = changes['filesData'].previousValue;
      this.dataSource.data = current;
    }
  }
}

  export interface DateRange {
  fromDate: Date | null;
  toDate: Date | null;
}
